import { render, staticRenderFns } from "./team-ring-groups-tooltip.vue?vue&type=template&id=428f42cb"
import script from "./team-ring-groups-tooltip.vue?vue&type=script&lang=js"
export * from "./team-ring-groups-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports